module.exports = __webpack_public_path__ + "img/icon_relation_detail.2a15b2a5.png";